module.exports = __webpack_public_path__ + "img/img-4.6293c0f2.webp";